import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import ConsultAnonymousCardDatatableRowMeta from "@Modules/cardManagementSystem/prepaid/containers/tableHandlers/card/consultAnonymousCard/ConsultAnonymousCardDatatableRowMeta";

export type TConsultAnonymousCardDataTableData = {
    primaryKey: string | number,
    creationDate: string,
    prepaidProgram: string,
    cardNumber: string,
    effectiveDate: string,
    expirationDate: string,
    available: string,
    cardStatus: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TConsultAnonymousCardDataTableData>()

export function getConsultAnonymousCardDataTableColumns({ isLoading, handleEdit }: Props) {
  
  return [
    columnHelper.accessor("creationDate",
        {
            id: "creationDate",
            header: "Date Creation",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("prepaidProgram",
        {
            id: "prepaidProgram",
            header: "Prog. prépayé",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("cardNumber",
        {
            id: "cardNumber",
            header: "Num Carte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),  
    columnHelper.accessor("effectiveDate",
        {
            id: "effectiveDate",
            header: "Date Effective",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("expirationDate",
        {
            id: "expirationDate",
            header: "Date Exp.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("available",
        {
            id: "available",
            header: "Disponible",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("cardStatus",
        {
            id: "cardStatus",
            header: "Statut carte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>{props.getValue()}</Center>
                </Skeleton>)
            },
        }
    ),
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <Button
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}
                            mr={'1rem'}
                        >
                            Editer
                        </Button>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
